<template>
  <div class="express-vue-temp">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "tf-vue-visas"
};
</script>

<style lang="scss">
@import "assets/scss/index";
// Example CSS can be added here
@import "assets/css/example.css";
</style>
